import { useUserRoles } from '@anytag/auth';
import { Form, RenderDataWithFallback } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { useInitAnalyticsFormValues } from './hooks';
import { getAnalyticsFormSchema } from './schema';
import { Template } from './Template';
import { AnalyticsFormValues } from './schemaTypes';

export type AnalyticsFormProps = FormAction<AnalyticsFormValues>;

export const AnalyticsForm = ({ onSubmit, defaultValues }: AnalyticsFormProps) => {
  const { role } = useUserRoles();
  const { values } = useInitAnalyticsFormValues({ defaultValues });

  return (
    <RenderDataWithFallback loading={!values}>
      <Form.Provider onSubmit={onSubmit} defaultValues={values} zodSchema={getAnalyticsFormSchema(role)}>
        <Template />
      </Form.Provider>
    </RenderDataWithFallback>
  );
};

export * from './utils';
export * from './schemaTypes';
